import Organisation from "../presentation/views/Organisation.vue";
import OrganisationList from "../presentation/views/OrganisationList.vue";
export const organisationRoutes = [
    {
        path: "/organisations",
        name: "OrganisationList",
        component: OrganisationList,
        meta: { requiresAuth: true, titleKey: "organisationList.title" },
    },
    {
        path: "/organisations/:id",
        name: "Organisation",
        component: Organisation,
        meta: { requiresAuth: true, titleKey: "organisation.title" },
    },
];
export const organisationNavigationItems = [
    {
        labelKey: "organisation.title",
        children: [
            {
                labelKey: "organisationList.title",
                path: "/organisations",
                meta: { requiresAuth: true },
            },
        ],
    },
];
